module.exports = __webpack_public_path__ + "img/second_two.f9b52d01.png";